import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import './MyOrders.css';

const MyOrders = () => {
  const navigate = useNavigate();
  const [userPhone, setUserPhone] = useState('');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const phone = localStorage.getItem('user_phone');
    if (!phone) {
      navigate('/login');
      return;
    }
    
    setUserPhone(phone);
    fetchOrders(phone);
  }, [navigate]);

  const fetchOrders = async (phone) => {
    console.log('Fetching orders for phone:', phone);
    try {
      // Use GET request with phone query parameter
      // Note: The backend needs to be updated to support 'phone' filter
      const response = await fetch(`https://panel.supplebakes.com/order/get-orders.php?phone=${encodeURIComponent(phone)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      console.log('API Response:', data);
      
      if (data.success) {
        // The KDS API returns orders in 'data' property
        setOrders(data.data || []);
      } else {
        console.warn('API returned success: false', data.message);
        setOrders([]);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user_phone');
    navigate('/');
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'paid': return 'status-paid';
      case 'completed': return 'status-completed';
      case 'failed': return 'status-failed';
      case 'cancelled': return 'status-cancelled';
      default: return 'status-pending';
    }
  };

  const handleViewReceipt = (orderId) => {
    const receiptUrl = `https://panel.supplebakes.com/receipt/?order_id=${orderId}`;
    if (window.cordova && window.cordova.InAppBrowser) {
        window.cordova.InAppBrowser.open(receiptUrl, '_system', 'location=yes');
    } else {
        window.open(receiptUrl, '_blank');
    }
  };

  return (
    <div className="my-orders-page">
      <Header title="My Profile" />
      <div className="container">
        
        {/* Profile Section */}
        <div className="profile-card glass-effect">
          <div className="profile-info">
            <div className="profile-avatar">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <div className="profile-details">
              <h3>Hello, User</h3>
              <p>{userPhone}</p>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-btn ripple">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
            </svg>
            Logout
          </button>
        </div>

        <h2 className="section-title">My Orders</h2>

        {loading ? (
          <div className="loading-spinner">Loading orders...</div>
        ) : (orders && orders.length > 0) ? (
          <div className="orders-list">
            {orders.map((order) => (
              <div key={order.id} className="order-card">
                <div className="order-header">
                  <div>
                    <div className="order-id">Order #{order.order_number || order.id}</div>
                    <div className="order-date">{new Date(order.created_at).toLocaleDateString()}</div>
                  </div>
                  <span className={`order-status ${getStatusClass(order.payment_status)}`}>
                    {order.payment_status || 'Pending'}
                  </span>
                </div>
                
                <div className="order-items">
                  {/* We might need to parse items if they are stored as JSON string, 
                      or just show summary if backend returns summary */}
                  <div className="order-item-summary">
                    <span>Total Items</span>
                    <span>{order.total_items || 1}</span>
                  </div>
                </div>

                <div className="order-footer">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span className="order-total-label">Total Amount</span>
                      <span className="order-total-amount">₹{parseFloat(order.total_amount).toFixed(2)}</span>
                    </div>
                    <button 
                      className="btn-secondary ripple" 
                      onClick={() => handleViewReceipt(order.id)}
                      style={{ 
                        width: '100%', 
                        padding: '0.5rem', 
                        fontSize: '0.9rem', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        gap: '0.5rem',
                        marginTop: '0.5rem',
                        background: '#f8f9fa',
                        color: '#555',
                        border: '1px solid #ddd'
                      }}
                    >
                      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                      </svg>
                      View Receipt
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-orders">
            <svg className="empty-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
            </svg>
            <h3>No orders yet</h3>
            <p>Your past orders will appear here.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrders;
